import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MaintenanceStatus } from '../core/services/maintenance-status.enum';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'environment-status',
  templateUrl: './environment-status.component.html',
  styleUrls: ['./environment-status.component.scss']
})
export class EnvironmentStatusComponent implements OnInit {

  public statusLabel: string = '';
  public backgroudStyle: string = '';
  public backgroudStyleBtn: string = '';
  public showLabelError: boolean = false;
  @Input() status: MaintenanceStatus = MaintenanceStatus.ACTIVE;
  @Output() verifyServiceAvailability = new EventEmitter();

  constructor(private _i18nService: I18nService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.showLabelError = false;
    if (this.status === MaintenanceStatus.ACTIVE) {
      this.statusLabel = this._i18nService.instant('MAINTENANCE.ENVIRONMENT_STATUS_RUNNING');
      this.backgroudStyle = 'environment-status environment-status-running';
      this.backgroudStyleBtn = 'environment-status-container__message environment-status-container__message-running';
    } else if (this.status === MaintenanceStatus.ERROR) {
      this.statusLabel = this._i18nService.instant('MAINTENANCE.ENVIRONMENT_STATUS_ERROR');
      this.backgroudStyle = 'environment-status environment-status-error';
      this.backgroudStyleBtn = 'environment-status-container__message environment-status-container__message-error';
      this.showLabelError = true;
    }
    else if (this.status === MaintenanceStatus.RESTARTING) {
      this.statusLabel = this._i18nService.instant('MAINTENANCE.ENVIRONMENT_STATUS_RESTARTING');
      this.backgroudStyle = 'environment-status environment-status-restarting';
      this.backgroudStyleBtn = 'environment-status-container__message environment-status-container__message-restarting';
    } else if (this.status === MaintenanceStatus.VERIFYING) {
      this.statusLabel = this._i18nService.instant('MAINTENANCE.ENVIRONMENT_STATUS_CHECKING');
      this.backgroudStyle = 'environment-status environment-status-restarting';
      this.backgroudStyleBtn = 'environment-status-container__message environment-status-container__message-restarting';
    } else {
      this.statusLabel = this._i18nService.instant('MAINTENANCE.ENVIRONMENT_STATUS_MAINTENANCE');
      this.backgroudStyle = 'environment-status environment-status-maintenance';
      this.backgroudStyleBtn = 'environment-status-container__message environment-status-container__message-maintenance';
    }
  }

  verifyService() {
    this.verifyServiceAvailability.emit();
  }

  get isError() {
    return this.status === MaintenanceStatus.ERROR;
  }
}
